import { EventObject } from 'xstate';
import { CustomerSearchInput } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { NetworkError } from '../../state-machine/actions/genericActions';
import { CustomerLookupEvents } from '../../state-machine/types/customerLookupMachine.types';
import { BasicInfoContinuedModel } from '../../state-machine/types/ecommMachine.types';
import { CustomerSearchRequestMachineContext } from '../../state-machine/types/shared/context/customerSearchMachineContext';
import { queryCustomers } from './queryCustomers';
import { CustomerSearchResult } from './queryCustomersByCellphone';

const queryCustomersByIDV = async (
  context: CustomerSearchRequestMachineContext,
  event: Last4SSNSubmittedEvent | BasicInfoContinuedSubmittedEvent,
): Promise<CustomerSearchResult> => {
  try {
    const customerCheckPayload: CustomerSearchInput = {
      orderId: context.orderId,
      cellPhone: context.cellPhone,
    };

    // when this function is called after last 4 ssn,
    // this block augments the request with that to return the existing customer
    if (isLast4Event(event) && event?.data?.taxIdLast4) {
      customerCheckPayload.taxIDLast4 = event.data?.taxIdLast4;
    } else if (isBasicInfoContinuedSubmittedEvent(event) && event?.data?.basicInfoContinued.taxpayerIdentificationNumber) {
      customerCheckPayload.taxId = event.data?.basicInfoContinued.taxpayerIdentificationNumber;
      customerCheckPayload.birthDate = event.data?.basicInfoContinued.birthDate;
    }

    return await queryCustomers(context, customerCheckPayload);
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export interface Last4SSNSubmittedEvent extends EventObject {
  type: typeof CustomerLookupEvents.LAST4SSN;
  data: {
    taxIdLast4: string;
  };
}

// export interface CustomerInfoChangedEvent extends EventObject {
//   type: 'CUSTOMER_INFO_CHANGED';
//   data: {
//     taxId: string;
//   };
// }

export interface BasicInfoContinuedSubmittedEvent extends EventObject {
  // TODO: this requires better typing to be commented back in
  // type: typeof CustomerLookupEvents.SUBMIT_BASICS_CONTINUED;
  data?: {
    basicInfoContinued: BasicInfoContinuedModel;
    didCustomerChange: boolean;
  };
}

function isLast4Event(e: Last4SSNSubmittedEvent | BasicInfoContinuedSubmittedEvent): e is Last4SSNSubmittedEvent {
  return e.type === CustomerLookupEvents.LAST4SSN;
}
function isBasicInfoContinuedSubmittedEvent(e: Last4SSNSubmittedEvent | BasicInfoContinuedSubmittedEvent): e is BasicInfoContinuedSubmittedEvent {
  return e.type === CustomerLookupEvents.SUBMIT_BASICS_CONTINUED;
}

export default queryCustomersByIDV;
